import React from 'react'
import { Header ,Footer, Counter, Map } from '../components/layout'
import { Hero, AboutUs, WhyManafith, Section4Home,Section5Home, Section6Home, Section7Home } from '../components/Home'

import {backgroundDark,backgroundLight} from "../assets/images"

import { useStateContext } from '../context/ContextProvider'
const Home = () => {
  const {currentMode}=useStateContext()
  const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
  return (
    <div className='w-full'
    style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <Header activeLink={"/"} />
     <Hero />

      
     
      
          <Counter />
          <AboutUs/>
  
      {/* section 3 */}
      <WhyManafith />
      
      {/* section 4 with gradient background */}
      
        {/* Content */}

          <Section4Home />

      <Section5Home />
      <Section6Home />
      <Section7Home />
   
      <Footer />
      {/* footer */}

    </div>
  )
}

export default Home